/**
 * Creates a React.SyntheticEvent with the given type and target.
 */
export function createSyntheticEvent<T extends Element>(
  type: string,
  target: T
): React.SyntheticEvent<T> {
  const event = new Event(type);
  Object.defineProperty(event, 'target', { writable: false, value: target });
  let prevented = false;
  let stopped = false;
  return {
    ...event,
    nativeEvent: event,
    currentTarget: target,
    target,
    isDefaultPrevented: () => prevented,
    isPropagationStopped: () => stopped,
    persist: () => {},
    preventDefault: () => {
      prevented = true;
      event.preventDefault();
    },
    stopPropagation: () => {
      stopped = true;
      event.stopPropagation();
    },
  };
}
